import clsx from 'clsx'
import { useMemo, type FC, type ComponentPropsWithoutRef } from 'react'

import { ERROR_MESSAGES } from '@/constants/common/message.constants'

type Props = ComponentPropsWithoutRef<'div'> & {
  code: 400 | 403 | 404
}

export const ErrorPage: FC<Props> = ({ code, className, ...props }) => {
  const { title, message } = useMemo(() => {
    switch (code) {
      case 400:
        return {
          title: '400 - Bad Request',
          message: ERROR_MESSAGES.INVALID_SEARCH_PARAMETERS
        }
      case 403:
        return {
          title: '403 - Forbidden',
          message: ERROR_MESSAGES.LOOKING_FOR_CANNOT_DISPLAYED
        }
      case 404:
        return {
          title: '404 - Page Not Found',
          message: ERROR_MESSAGES.LOOKING_FOR_COULD_NOT_FOUND
        }
    }
  }, [code])
  return (
    <div
      {...props}
      className={clsx([
        'flex min-h-screen flex-col items-center justify-center',
        className
      ])}
    >
      <div className="text-center">
        <div className="text-4xl font-extrabold text-gray-300">{title}</div>
        <div className="py-5 text-base font-extrabold">{message}</div>
      </div>
    </div>
  )
}
